// Offline Booking Action Types
export const FETCH_OFFLINE_BOOKINGS = 'FETCH_OFFLINE_BOOKINGS';
export const FETCH_OFFLINE_BOOKINGS_SUCCESS = 'FETCH_OFFLINE_BOOKINGS_SUCCESS';
export const FETCH_OFFLINE_BOOKINGS_FAIL = 'FETCH_OFFLINE_BOOKINGS_FAIL';

export const CREATE_OFFLINE_BOOKING = 'CREATE_OFFLINE_BOOKING';
export const CREATE_OFFLINE_BOOKING_SUCCESS = 'CREATE_OFFLINE_BOOKING_SUCCESS';
export const CREATE_OFFLINE_BOOKING_FAIL = 'CREATE_OFFLINE_BOOKING_FAIL';

export const UPDATE_OFFLINE_BOOKING = 'UPDATE_OFFLINE_BOOKING';
export const UPDATE_OFFLINE_BOOKING_SUCCESS = 'UPDATE_OFFLINE_BOOKING_SUCCESS';
export const UPDATE_OFFLINE_BOOKING_FAIL = 'UPDATE_OFFLINE_BOOKING_FAIL';

export const DELETE_OFFLINE_BOOKING = 'DELETE_OFFLINE_BOOKING';
export const DELETE_OFFLINE_BOOKING_SUCCESS = 'DELETE_OFFLINE_BOOKING_SUCCESS';
export const DELETE_OFFLINE_BOOKING_FAIL = 'DELETE_OFFLINE_BOOKING_FAIL';

export const FETCH_SPACES_FOR_BOOKING = 'FETCH_SPACES_FOR_BOOKING';
export const FETCH_SPACES_FOR_BOOKING_SUCCESS = 'FETCH_SPACES_FOR_BOOKING_SUCCESS';
export const FETCH_SPACES_FOR_BOOKING_FAIL = 'FETCH_SPACES_FOR_BOOKING_FAIL';

export const SEARCH_SPACES_FOR_BOOKING = 'SEARCH_SPACES_FOR_BOOKING';
export const SEARCH_SPACES_FOR_BOOKING_SUCCESS = 'SEARCH_SPACES_FOR_BOOKING_SUCCESS';
export const SEARCH_SPACES_FOR_BOOKING_FAIL = 'SEARCH_SPACES_FOR_BOOKING_FAIL';

export const FETCH_SPACE_BY_ID = 'FETCH_SPACE_BY_ID';
export const FETCH_SPACE_BY_ID_SUCCESS = 'FETCH_SPACE_BY_ID_SUCCESS';
export const FETCH_SPACE_BY_ID_FAIL = 'FETCH_SPACE_BY_ID_FAIL';

export const FETCH_SPACE_BOOKINGS = 'FETCH_SPACE_BOOKINGS';
export const FETCH_SPACE_BOOKINGS_SUCCESS = 'FETCH_SPACE_BOOKINGS_SUCCESS';
export const FETCH_SPACE_BOOKINGS_FAIL = 'FETCH_SPACE_BOOKINGS_FAIL';

export const CLEAR_OFFLINE_BOOKING_ERROR = 'CLEAR_OFFLINE_BOOKING_ERROR';
export const RESET_OFFLINE_BOOKING_FORM = 'RESET_OFFLINE_BOOKING_FORM';
export const CLEAR_SPACE_DETAILS = 'CLEAR_SPACE_DETAILS';

// Offline Booking Payment Action Types
export const CREATE_OFFLINE_PAYMENT = 'CREATE_OFFLINE_PAYMENT';
export const CREATE_OFFLINE_PAYMENT_SUCCESS = 'CREATE_OFFLINE_PAYMENT_SUCCESS';
export const CREATE_OFFLINE_PAYMENT_FAIL = 'CREATE_OFFLINE_PAYMENT_FAIL';

export const UPDATE_OFFLINE_PAYMENT = 'UPDATE_OFFLINE_PAYMENT';
export const UPDATE_OFFLINE_PAYMENT_SUCCESS = 'UPDATE_OFFLINE_PAYMENT_SUCCESS';
export const UPDATE_OFFLINE_PAYMENT_FAIL = 'UPDATE_OFFLINE_PAYMENT_FAIL';

export const FETCH_OFFLINE_PAYMENT = 'FETCH_OFFLINE_PAYMENT';
export const FETCH_OFFLINE_PAYMENT_SUCCESS = 'FETCH_OFFLINE_PAYMENT_SUCCESS';
export const FETCH_OFFLINE_PAYMENT_FAIL = 'FETCH_OFFLINE_PAYMENT_FAIL';

// Calendar Data Action Types (for displaying all booking types)
export const FETCH_CALENDAR_DATA = 'FETCH_CALENDAR_DATA';
export const FETCH_CALENDAR_DATA_SUCCESS = 'FETCH_CALENDAR_DATA_SUCCESS';
export const FETCH_CALENDAR_DATA_FAIL = 'FETCH_CALENDAR_DATA_FAIL';

// Client search (existing users) for Offline Booking
export const SEARCH_CLIENTS = 'SEARCH_CLIENTS';
export const SEARCH_CLIENTS_SUCCESS = 'SEARCH_CLIENTS_SUCCESS';
export const SEARCH_CLIENTS_FAIL = 'SEARCH_CLIENTS_FAIL';
export const CLEAR_CLIENT_SUGGESTIONS = 'CLEAR_CLIENT_SUGGESTIONS';

// Booking Availability Action Types
export const FETCH_BOOKING_AVAILABILITY = 'FETCH_BOOKING_AVAILABILITY';
export const FETCH_BOOKING_AVAILABILITY_SUCCESS = 'FETCH_BOOKING_AVAILABILITY_SUCCESS';
export const FETCH_BOOKING_AVAILABILITY_FAIL = 'FETCH_BOOKING_AVAILABILITY_FAIL';
export const CLEAR_BOOKING_AVAILABILITY = 'CLEAR_BOOKING_AVAILABILITY';

// Confirm/Cancel Offline Booking Action Types
export const CONFIRM_OFFLINE_BOOKING = 'CONFIRM_OFFLINE_BOOKING';
export const CONFIRM_OFFLINE_BOOKING_SUCCESS = 'CONFIRM_OFFLINE_BOOKING_SUCCESS';
export const CONFIRM_OFFLINE_BOOKING_FAIL = 'CONFIRM_OFFLINE_BOOKING_FAIL';

export const CANCEL_OFFLINE_BOOKING = 'CANCEL_OFFLINE_BOOKING';
export const CANCEL_OFFLINE_BOOKING_SUCCESS = 'CANCEL_OFFLINE_BOOKING_SUCCESS';
export const CANCEL_OFFLINE_BOOKING_FAIL = 'CANCEL_OFFLINE_BOOKING_FAIL';
